import styles from "./RadioGroup.module.css";
import { classnames } from "../../utils/index.jsx";

export default function RadioGroup({
  children,
  onChange,
  className,
  layout,
  styling = "button-style",
  marginForm = "margin-form",
}) {
  return (
    <fieldset
      className={classnames(
        marginForm,
        styles[styling],
        styles[layout],
        styles.default,
        className,
      )}
      onChange={onChange}
    >
      {children}
    </fieldset>
  );
}
